import { Component, inject, OnInit } from '@angular/core';
import { GlobalService } from '@core/services/global.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  standalone: false,
  selector: 'app-page-not-authorized',
  templateUrl: './page-not-authorized.component.html',
  styleUrl: './page-not-authorized.component.scss',
})
export class PageNotAuthorizedComponent implements OnInit {
  private readonly oAuthService: OAuthService = inject(OAuthService);
  private readonly globalService: GlobalService = inject(GlobalService);

  isConnected: boolean = false;

  ngOnInit(): void {
    this.isConnected = this.globalService.getCurrentUserData()?.active ?? false;
  }
  public login(): void {
    this.oAuthService.initCodeFlow();
  }
}
